<template>
  <table
    v-if="orders.length" 
    class="c-orders-list"
  >
    <thead class="c-orders-list__head">
      <tr class="c-orders-list__row c-orders-list__row">
        <th
          scope="col"
          class="c-orders-list__heading t-heading-6"
        >
          Order
        </th>
        <th
          scope="col"
          class="c-orders-list__heading t-heading-6"
        >
          Date
        </th>
        <th
          scope="col"
          class="c-orders-list__heading t-heading-6"
        >
          Payment Status
        </th>
        <th
          scope="col"
          class="c-orders-list__heading t-heading-6"
        >
          Fulfillment Status
        </th>
        <th
          scope="col"
          class="c-orders-list__heading t-heading-6"
        >
          Total
        </th>
      </tr>
    </thead>
    <tbody class="c-orders-list__body">
      <tr
        v-for="order in orders"
        :key="order.name"
        class="c-orders-list__row u-margin-bottom-x-small"
      >
        <td class="c-orders-list__cell c-orders-list__cell--order-number l-grid l-grid--no-gap l-grid--2-col-fixed">
          <span class="c-orders-list__mobile-label u-text-align-left l-grid__item--justify-start t-heading-9">Order:</span>
          <a
            :href="order.url"
            class="t-link c-orders-list__cell-link l-grid__item--justify-end"
          >
            {{ order.name }}
          </a>
        </td>
        <td class="c-orders-list__cell l-grid l-grid--no-gap l-grid--2-col-fixed">
          <span class="c-orders-list__mobile-label u-text-align-left l-grid__item--justify-start t-heading-9">Date:</span>
          {{ order.date }}
        </td>
        <td class="c-orders-list__cell l-grid l-grid--no-gap l-grid--2-col-fixed">
          <span class="c-orders-list__mobile-label u-text-align-left l-grid__item--justify-start t-heading-9">Payment Status:</span>
          {{ order.financialStatus }}
        </td>
        <td class="c-orders-list__cell l-grid l-grid--no-gap l-grid--2-col-fixed">
          <span class="c-orders-list__mobile-label u-text-align-left l-grid__item--justify-start t-heading-9">Fulfillment Status:</span>
          {{ order.fulfillmentStatus }}
        </td>
        <td class="c-orders-list__cell l-grid l-grid--no-gap l-grid--2-col-fixed">
          <span class="c-orders-list__mobile-label u-text-align-left l-grid__item--justify-start t-heading-9">Total:</span>
          {{ order.total }}
        </td>
      </tr>
    </tbody>
  </table>
  <p
    v-else
    class="u-text-align-center"
  >
    <strong>You haven't placed any orders yet.</strong>
  </p>
</template>

<script>
export default {
  name: 'OrderTable',
  props: {
    orders: {
      type: Array,
      default: () => [],
    },
  }
}
</script>

<style lang="scss" scoped>
.c-orders-list {
  min-width: 100%;
  flex-basis: 100%;    
  border-collapse: collapse;

  @include respond-min('desktop') {
    text-align: left;
  }

  &__row {
    display: block;
    padding-bottom: rem(10px);
    @include themify($themes) {
      border-bottom: $border themed('foreground', 'light');
    }

    @include respond-min('desktop') {
      grid-template-columns: repeat(5, 1fr);
      padding-bottom: 0; 

      @include themify($themes) {
        border-bottom: 0;
      }
    }
  
    .c-orders-list__head & {
      position: absolute;
      top: -9999px;
      left: -9999px;

      @include respond-min('desktop') {
        position: static;
      }
    }
  }

  &__body,
  &__row {
    @include respond-min('desktop') {
      display: grid;
    }
  }  
  
  &__heading,
  &__cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: rem(5px) rem(10px);
  }
  
  &__heading {
    @include themify($themes) {
      background: themed('background', 'xx-light');
      border-top: 2px solid themed('background', 'dark');
    }

    @include respond-min('desktop') {
      padding: rem(10px);
    }
  }
  
  &__cell {
    position: relative;
    text-align: right;
    border: 0;
  
    @include respond-min('desktop') {
      display: block;
      text-align: left;
      padding: rem(5px) rem(10px);
    }
  }

  &__cell-link {
    margin-left: auto;

    @include respond-min('desktop') {
      margin-left: 0;
    }
  }
  
  &__mobile-label {
    white-space: nowrap;
  
    @include respond-min('desktop') {
      display: none;
    }
  }
}
</style>